import { Spinner } from 'react-bootstrap'

export default function Loader() {
  return (
    <div style={{ height: '100vh',zIndex:555, position:'absolute',top:'0', width: '99vw', display: 'flex', justifyContent: 'center', alignItems: 'center',backdropFilter: "blur(10px)" }}>
          <Spinner variant='primary'  style={{width:'100px',height:'100px'}}/>
    </div>
  )
}
